<template>
  <b-card :footer="footer" :footer-tag="footerTag" no-body>
    <b-card-body>
      <slot name="title">
        <h4 class="card-title" :class="titleClass">{{ title }}
          <info-popup v-if="info" :value="info" />
        </h4>
      </slot>
      <slot></slot>
    </b-card-body>
    <slot name="footer"></slot>
  </b-card>
</template>

<script>
import InfoPopup from '@/components/Custom/InfoPopup';

export default {
  name: "RCard",
  components: {
    InfoPopup,
  },
  props: {
    title: {
      type: String,
    },
    footer: {
      type: String,
    },
    footerTag: {
      type: String,
    },
    info: {
      type: String,
    },
    titleClass: {
      type: String,
    },
  },
}
</script>

<style scoped>
  h4 {
    font-size: 12px;
    font-weight: bold;
  }
  .card-footer {
    border-top: 0;
    background: #F7F9FC;
  }
  .card {
    border: 0;
    border-radius: 0;
    box-shadow: 1px 1px #CCD9E2;
  }
</style>
